import { useI18n } from '@/context/I18nContext';
import { CrudPage, type CrudColumn, type CrudField } from '@/components/crud/CrudPage';

interface SparkPlug {
  id: string;
  brand: string;
  type: string;
  nr?: string;
  teamId: string;
}

export function SparkPlugsTab({ teamId, readOnly }: { teamId: string; readOnly?: boolean }) {
  const { t } = useI18n();

  const columns: CrudColumn<SparkPlug>[] = [
    { key: 'brand', label: t('common.brand') },
    {
      key: 'type',
      label: t('common.type'),
      render: (e) => (
        <span className="inline-block px-2.5 py-0.5 bg-accent-subtle border border-accent/20 rounded-full text-xs font-medium text-accent-hover tracking-wide">
          {e.type}
        </span>
      ),
    },
    {
      key: 'nr',
      label: t('common.nr'),
      className: 'w-[100px] text-text-secondary text-sm',
      render: (e) => e.nr || <span className="text-text-muted">—</span>,
    },
  ];

  const fields: CrudField[] = [
    { key: 'brand', label: t('common.brand'), placeholder: 'e.g. NGK' },
    { key: 'type', label: t('common.type'), placeholder: 'e.g. R6252K' },
    { key: 'nr', label: t('common.nr'), placeholder: 'e.g. 1', info: t('common.nrInfo'), optional: true, defaultValue: (items) => String(items.length + 1) },
  ];

  return (
    <CrudPage<SparkPlug>
      title={t('materials.tab.spark_plugs')}
      entityName={t('materials.entity.spark_plug')}
      emptyIcon="⚡"
      columns={columns}
      fields={fields}
      listMethod="ListSparkPlugs"
      createMethod="CreateSparkPlug"
      updateMethod="UpdateSparkPlug"
      deleteMethod="DeleteSparkPlug"
      listParams={{ teamId }}
      readOnly={readOnly}
      hiddenValues={{ teamId }}
    />
  );
}
